module.exports = __webpack_public_path__ + "app-static/img/ysx.43ff2908.png";